import { render, staticRenderFns } from "./RedesignTeamDetailsEqu.vue?vue&type=template&id=79560420&scoped=true"
import script from "./RedesignTeamDetailsEqu.vue?vue&type=script&lang=js"
export * from "./RedesignTeamDetailsEqu.vue?vue&type=script&lang=js"
import style0 from "./RedesignTeamDetailsEqu.vue?vue&type=style&index=0&id=79560420&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./RedesignTeamDetailsEqu.vue?vue&type=style&index=1&id=79560420&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79560420",
  null
  
)

export default component.exports